/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import styles from "./CampaignWinner.module.css";
import { SettingOutlined } from '@ant-design/icons';
import LuckyDraw from "../../Images/luckydraw.png";
import { FaArrowLeft } from "react-icons/fa";
import { Table, Input, Pagination, Space, Dropdown, Checkbox, Tag, Button, notification, Carousel } from 'antd';
import { CiSearch } from 'react-icons/ci';
import * as Actions from '../../store/slices/getCompletedCampaign'
import { connect } from 'react-redux';
import { Modal, Select, Form, message, Tabs } from "antd";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Header from "../../components/Header/header";
import { hasPermission } from "../../utils/premission";
import { PERMISSIONS } from "../../utils/constant/permissions";
import { getDecodedToken } from "../../utils/auths";
import { useNavigate } from 'react-router-dom';

import Sheikh from "../../Images/oman2.png";
import Sheikh1 from "../../Images/oman3.png";
import Coin_1st from "../../Images/1stWinnerTag.png";
import Coin_2nd from "../../Images/2ndWinnerTag.png";
import Coin_3rd from "../../Images/3rdWinnerTag.png";

import { FaArrowRightLong } from "react-icons/fa6";
import { IoCloseSharp } from "react-icons/io5";
import { Card, Spin } from "antd";
const { Option } = Select;
const { Meta } = Card;

// ─── Slot Machine Lucky Draw ───────────────────────────────────────────────
interface SlotProps {
  winners: { customerId: string; customerName?: string | null; prize: string; prizeLabel: string; position: number }[];
  onDone: () => void;
  getCustomerNameFn: (name: string | null | undefined) => string | null;
  winnerList: any[];
  stylesRef: any;
}

const DUMMY_IDS = [
  '1601-000001-001','1601-000002-002','1601-000003-003','1601-000004-004',
  '1601-000005-005','1601-000006-006','1601-000007-007','1601-000008-008',
  '1601-000009-009','1601-000010-010','1601-000011-011','1601-000012-012',
  '1601-000013-013','1601-000014-014','1601-000015-015','1601-000016-016',
];

const COIN_IMGS: Record<number, string> = {};

const SlotMachine: React.FC<SlotProps> = ({ winners, onDone, getCustomerNameFn, winnerList, stylesRef }) => {
  const [displayIds, setDisplayIds] = useState<string[]>(winners.map(() => DUMMY_IDS[0]));
  const [revealed, setRevealed] = useState<boolean[]>(winners.map(() => false));
  const [currentSlot, setCurrentSlot] = useState(0);
  const [allDone, setAllDone] = useState(false);
  const timerRef = useRef<any>(null);

  useEffect(() => {
    if (currentSlot >= winners.length) {
      setAllDone(true);
      timerRef.current = setTimeout(onDone, 5000);
      return;
    }
    runSlot(currentSlot);
    return () => { if (timerRef.current) clearTimeout(timerRef.current); };
  }, [currentSlot]);

  const runSlot = (idx: number) => {
    const target = winners[idx].customerId;
    let elapsed = 0;
    let delay = 55;
    const total = 2600 + idx * 500;

    const tick = () => {
      elapsed += delay;
      const rand = DUMMY_IDS[Math.floor(Math.random() * DUMMY_IDS.length)];
      setDisplayIds(prev => prev.map((v, i) => i === idx ? rand : v));

      if (elapsed > total * 0.55) delay = Math.min(delay + 22, 300);

      if (elapsed >= total) {
        setDisplayIds(prev => prev.map((v, i) => i === idx ? target : v));
        setRevealed(prev => prev.map((v, i) => i === idx ? true : v));
        timerRef.current = setTimeout(() => setCurrentSlot(c => c + 1), 700);
      } else {
        timerRef.current = setTimeout(tick, delay);
      }
    };
    timerRef.current = setTimeout(tick, delay);
  };

  // coin image per position
  const getCoinSrc = (pos: number) => {
    if (pos === 1) return Coin_1st;
    if (pos === 2) return Coin_2nd;
    return Coin_3rd;
  };

  return (
    <div style={{ padding: '8px 0' }}>
      {winners.map((w, idx) => {
        const isSpinning = idx === currentSlot;
        const isRevealed = revealed[idx];
        const isPending = idx > currentSlot;
        const origItem = winnerList[idx] || {};

        return (
          <div
            key={idx}
            className={`row my-3 ${stylesRef.winnerRow}`}
            style={{
              opacity: isPending ? 0.45 : 1,
              transition: 'opacity 0.4s',
            }}
          >
            {/* LEFT: coin + customer id */}
            <div className={`col-lg-8 ${stylesRef.WinnerAnnauce}`}>
              {/* coin image */}
              <div className={stylesRef.imagewinner}>
                <img
                  src={getCoinSrc(w.position)}
                  width={72}
                  alt={`Position ${w.position}`}
                  style={{
                    filter: isSpinning ? 'brightness(1.3) drop-shadow(0 0 8px gold)' : 'none',
                    transition: 'filter 0.3s',
                  }}
                />
              </div>

              {/* shuffling / revealed customer id */}
              <span className={stylesRef.Prize}>
                <h5 style={{
                  fontFamily: 'monospace',
                  fontSize: isSpinning ? 16 : 17,
                  color: isRevealed ? '#1a1f36' : isSpinning ? '#095179' : '#aaa',
                  letterSpacing: isSpinning ? 1 : 0,
                  filter: isSpinning ? 'blur(0.4px)' : 'none',
                  transition: 'color 0.3s, filter 0.2s',
                  margin: 0,
                }}>
                  {isPending ? '• • • • • • • • • •' : `Customer Id : ${displayIds[idx]}`}
                </h5>
                {isRevealed && getCustomerNameFn(w.customerName) && (
                  <h5 style={{ fontSize: 13, color: '#5a5f7d', margin: '2px 0 0' }}>
                    {`Customer Name : ${getCustomerNameFn(w.customerName)}`}
                  </h5>
                )}
                {isSpinning && (
                  <span style={{ fontSize: 11, color: '#bbb', letterSpacing: 3 }}>DRAWING...</span>
                )}
              </span>
            </div>

            {/* RIGHT: dark blue position/prize card */}
            <div className={`col-lg-3 ${stylesRef.Amount}`}>
              <span>
                <h6>{`Position ${w.position}`}</h6>
                <h3>{`${w.prizeLabel} : ${w.prize}`}</h3>
                <h2>{origItem.campaignWinner?.winnerFrequency || 'Current Month'}</h2>
              </span>
              <span className={stylesRef.Arrow}>
                {isRevealed && (
                  <FaArrowRightLong className={stylesRef.arrowICon} />
                )}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};
// ──────────────────────────────────────────────────────────────────────────
interface DataSource {
  key: string;
  CampaignName: string;
  StartTime: string;
  createdAt: string;
  EndTime: string;
  noOfWinners: string;
  winnerFrequency: string;
  campaignId: string;
  campaignStatus: string;
}

interface AnnounceWinnerResponse {
  success: boolean;
  message?: string;
}

interface TransactionResponse {
  success: boolean;
  message?: string;
}

interface HistoryResponse {
  success: boolean;
  message?: string;
}

interface getData {
  getCompletedCampaign: () => void,
  getCampaignsWithStatus: () => void,
  getCompletedCampaign_Red: any;
  getRanges: (campaignId: string) => void;
  getHistoryTransaction: (campaignId: string) => unknown;
  getTransaction: (campaignId: any, startRange: string, endRange: string) => unknown;
  AnnounceWinner: (campaignData: any) => unknown;
  getWinnerTransaction: (campaignId: any, campaignWinnerId: any) => void;
  blacklistCreate: (campaignId: number, campaignWinnerId: number, comments?: string) => any;
  blacklistDelete: (id: number) => any;
  getCampaignById: (campaignId: string) => any;
  getExecutedWinners: (campaignId: string, startRange: string, endRange: string) => any;
}


interface Winner {
  customer: string;
  location: string;
  prize: string;
  transactionId: number;
  transactionDate: string;
  transactionSummary?: {
    customer_name: string;
    total_amount: number;
    transaction_id: number;
  };
  campaignWinner?: {
    campaignWinnerId: number;
    prizeAmount: string;
    prizeGift: string;
    prizeType: string;
    winningEndRange: string;
    winningPosition: string;
    winningStartRange: string;
  }
}

interface CampaignResponse {
  key: string;
  campaignWinnerId: number;
  transactionLogs: Array<{
    transactionId: number;
    branchCode: string;
    customer: string;
    suffix: string;
    postingDate: string;
    valueDate: string;
    inputBranch: string;
    userGroup: string;
    referenceID: string;
    transactionCode: string;
    transactionCodeDesc: string;
    currency: string;
    debitCredit: string;
    timeStamp: string;
    narrationLine1: string;
    narrationLine2: string;
    narrationLine3?: string;
    narrationLine4?: string;
    amount: number;
    createdAt: string | null;
    updatedAt: string | null;
  }>;
}

declare module "jspdf" {
  interface jsPDF {
    autoTable: (options: any) => jsPDF;
  }
}

const LuckyDrawScreen: React.FC<getData> = ({ getCompletedCampaign_Red, getCompletedCampaign, getCampaignsWithStatus, getRanges, getTransaction, AnnounceWinner, getWinnerTransaction, getHistoryTransaction, blacklistCreate, blacklistDelete, getCampaignById, getExecutedWinners }) => {

  const getCustomerName = (name: string | null | undefined): string | null => {
    if (!name || name.trim() === '') return null;
    return name.trim();
  };
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<string>('completed');
  const [activeCampaignGroup, setActiveCampaignGroup] = useState<boolean>(false);
  const [activeCampaign, setActiveCampaign] = useState<boolean>(false);
  const [spinning, setSpinning] = useState(false);
  const [boom, setBoom] = useState(false);
  const [searchText, setSearchText] = useState<string>('');
  const [selectedColumns, setSelectedColumns] = useState<string[]>([ 'campaignId', 'CampaignName', 'createdAt', 'StartTime', 'EndTime', 'campaignStatus', 'noOfWinners']);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedStartRange, setSelectedStartRange] = useState<string>('');
  const [selectedEndRange, setSelectedEndRange] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(9);
  const [loadingText, setLoadingText] = useState<boolean>(true)
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const [open, setOpen] = useState(false);
  const [showForm, setShowForm] = useState<boolean>(false);
  const [modalText, setModalText] = useState<string>('')
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [Data, setData] = useState(getCompletedCampaign_Red.data[0]?.res)
  const [currentRowKey, setCurrentRowKey] = useState<string | null>(null);
  const [Winnners, setWinnners] = useState<Winner[] | undefined>(getCompletedCampaign_Red?.winner);
  const [campaignStatus, setCampaignStatus] = useState<string>('');
  const [selectedCampaignName, setSelectedCampaignName] = useState<string>('');
  const [selectedWinnerDetails, setSelectedWinnerDetails] = useState<Winner | null>(null);
  const [isTransactionModalVisible, setIsTransactionModalVisible] = useState(false);
  const [showSelectWinner, setShowSelectWinner] = useState<boolean>(false)
  const [transactionData, setTransactionData] = useState<CampaignResponse[]>([]);
  const [showCarousel, setCarousel] = useState(false)
  const [actionType, setActionType] = useState("");
  const [selectedWinnerIds, setSelectedWinnerIds] = useState<number[]>([]);
  const [auditLoading, setAuditLoading] = useState<boolean>(false);
  const [lastExecutedRange, setLastExecutedRange] = useState<string>('');
  const [replaceCommentModal, setReplaceCommentModal] = useState(false);
  const [replaceComment, setReplaceComment] = useState('');

  const handleReplaceWinner = async () => {
    if (selectedWinnerIds.length === 0) {
      notification.warning({ message: 'Please select at least one winner to replace.' });
      return;
    }
    // open comment modal first
    setReplaceComment('');
    setReplaceCommentModal(true);
  };

  const confirmReplaceWinner = async () => {
    setReplaceCommentModal(false);
    try {
      setSpinning(true);
      const winnersToReplace = getCompletedCampaign_Red?.winner?.filter(
        (item: any) => selectedWinnerIds.includes(item.campaignWinner?.campaignWinnerId)
      );

      for (const item of winnersToReplace) {
        const campaignWinnerId = item?.campaignWinner?.campaignWinnerId;
        const campaignId = Number(currentRowKey);
        if (campaignWinnerId && campaignId) {
          const res = await blacklistCreate(campaignId, campaignWinnerId, replaceComment);
          if (!res.success) {
            notification.error({ message: res.message || res.exceptionMsg || 'Replace winner failed' });
            setSpinning(false);
            return;
          }
        }
      }

      notification.success({ message: 'Selected winners blacklisted. Refreshing winners...' });
      setSelectedWinnerIds([]);

      // Reload executed winners using the last executed range
      const [startRange, endRange] = lastExecutedRange.split('To').map((r) => r.trim());
      const res = await getExecutedWinners(currentRowKey as string, startRange, endRange) as any;

      if (res.success) {
        const winners: any[] = Array.isArray(res.data) ? res.data : [];
        const hasData = winners.some((item: any) => item?.transactionSummary != null);
        if (!hasData) {
          notification.error({ message: 'No Data Found', description: 'No executed winner data was found.' });
          setSpinning(false);
          return;
        }
        notification.success({ message: 'Winners Refreshed Successfully' });
        setActiveCampaignGroup(true);
        setActiveCampaign(true);
        setCarousel(false);
      } else {
        const errorMsg = res.exceptionMsg || res.message || 'Failed to refresh winners.';
        notification.error({ message: 'Error', description: errorMsg });
      }
    } catch (error) {
      notification.error({ message: 'Failed to replace winner.' });
    } finally {
      setSpinning(false);
    }
  };



  console.log(actionType)
  const [dataSource, setDataSource] = useState<DataSource[]>([
    {
      key: '1',
      CampaignName: Data?.[0]?.campaignName || 'N/A',
      StartTime: Data?.[0]?.startDate || 'N/A',
      createdAt: Data?.[0]?.createdAt || 'N/A',
      EndTime: Data?.[0]?.endDate || 'N/A',
      noOfWinners: Data?.[0]?.noOfWinners || 'N/A',
      winnerFrequency: Data?.[0]?.winnerFrequency || 'N/A',
      campaignId: Data?.[0]?.campaignId || 'N/A',
      campaignStatus: Data?.[0]?.campaignStatus || 'N/A',
    },
  ]);





  useEffect(() => {
    const source = activeTab === 'completed'
      ? getCompletedCampaign_Red.data[0]?.res
      : activeTab === 'executed'
        ? getCompletedCampaign_Red.dataWithStatus?.[0]?.res?.filter((item: any) => item.campaignStatus === 'EXECUTED')
        : activeTab === 'archived'
          ? getCompletedCampaign_Red.dataWithStatus?.[0]?.res?.filter((item: any) => item.campaignStatus === 'ARCHIVED')
          : getCompletedCampaign_Red.dataWithStatus?.[0]?.res;
    if (source) {
      setData(source);
      setDataSource(
        source.map((item: any, index: number) => ({
          key: index.toString(),
          CampaignName: item.campaignName || 'N/A',
          StartTime: item.startDate || 'N/A',
          createdAt: item.createdAt.replace("T", "    ").split('.')[0] || 'N/A',
          EndTime: item.endDate || 'N/A',
          noOfWinners: item.noOfWinners || 'N/A',
          winnerFrequency: item.winnerFrequency || 'N/A',
          campaignId: item.campaignId || 'N/A',
          campaignStatus: item?.campaignStatus || 'N/A',
        }))
      );
    } else if (getCompletedCampaign_Red?.dataSingle?.[0]?.res?.status === '1004') {
      message.error(getCompletedCampaign_Red.dataSingle[0].res.message);
      localStorage.clear();
      navigate('/');
    } else if (getCompletedCampaign_Red?.dataSingle?.[0]?.res?.status === '1005') {
      message.warning(getCompletedCampaign_Red.dataSingle[0].res.message);
      setData([]);
      setDataSource([]);
    } else {
      setData([]);
      setDataSource([]);
    }
  }, [getCompletedCampaign_Red, navigate, activeTab]);






  const onSearch = (value: string) => setSearchText(value.toLowerCase());

  const handleCheckboxChange = (checked: boolean, column: string) => {
    setSelectedColumns((prevSelected) =>
      checked ? [...prevSelected, column] : prevSelected.filter((col) => col !== column)
    );
  };






  const handleBackClick = () => {
    setActiveCampaign(false);
    setActiveCampaignGroup(false);
    setSpinning(true);
    setTimeout(() => {
      if (activeTab === 'completed') { getCompletedCampaign(); } else { getCampaignsWithStatus(); }
      setSpinning(false);
    }, 2000);
  };



  useEffect(() => {
    setLoadingText(true)
    setTimeout(() => {
      setLoadingText(false)
    }, 2000)
  }, [])





  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedStartRange('');
    setCampaignStatus('');
  };


  const allColumns = [
 
    {
      title: 'Campaign ID',
      dataIndex: 'campaignId',
      key: 'campaignId',
      width: 100,
    },
    {
      title: 'Campaign Name',
      dataIndex: 'CampaignName',
      key: 'CampaignName',
      width: 150,
      sorter: (a: DataSource, b: DataSource) => a.CampaignName.localeCompare(b.CampaignName),
    },


    {
      title: 'Start Time',
      dataIndex: 'StartTime',
      key: 'StartTime',
      width: 120,
      sorter: (a: DataSource, b: DataSource) => new Date(a.StartTime).getTime() - new Date(b.StartTime).getTime(),
    },
    {
      title: 'End Time',
      dataIndex: 'EndTime',
      key: 'EndTime',
      width: 100,
      sorter: (a: DataSource, b: DataSource) => new Date(a.EndTime).getTime() - new Date(b.EndTime).getTime(),
    },


    {
      title: 'No Of Winners',
      dataIndex: 'noOfWinners',
      key: 'noOfWinners',
      width: 50,
    },
    {
      title: 'Winner Frequency',
      dataIndex: 'winnerFrequency',
      key: 'winnerFrequency',
      width: 150,
      sorter: (a: DataSource, b: DataSource) => parseFloat(a.winnerFrequency) - parseFloat(b.winnerFrequency),
    },
    {
      title: 'Campaign Status',
      dataIndex: 'campaignStatus',
      key: 'campaignStatus',
      width: 150,
      sorter: (a: DataSource, b: DataSource) => parseFloat(a.campaignStatus) - parseFloat(b.campaignStatus),
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 150,
      sorter: (a: DataSource, b: DataSource) => new Date(a.createdAt).getDate() - new Date(b.createdAt).getDate(),
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right' as const,
      width: 100,
      render: (record: DataSource) => {
        const isCompleted = record.campaignStatus === 'COMPLETED';
        const isExecuted = record.campaignStatus === 'EXECUTED';
        const isExecutable = record.campaignStatus === 'EXECUTE' || record.campaignStatus === 'APPROVED';
        const isArchived = record.campaignStatus === 'ARCHIVED';
        return (
          <>
            {isCompleted ? (
              hasPermission(PERMISSIONS.CAMPAIGN_WINNER_VIEW) && (
                <Button onClick={() => handleView(record.CampaignName, record.campaignId, record.campaignStatus)}>
                  View
                </Button>
              )
            ) : isExecuted ? (
              hasPermission(PERMISSIONS.CAMPAIGN_WINNER_EXECUTE) && (
                <Button
                  onClick={() => handleCampaignSelection(record.campaignId, record.CampaignName, record.campaignStatus)}
                >
                 Executed
                </Button>
              )
            ) : isArchived ? (
              <Space>
                {hasPermission(PERMISSIONS.CAMPAIGN_WINNER_VIEW) && (
                  <Button onClick={() => handleView(record.CampaignName, record.campaignId, record.campaignStatus)}>
                    View
                  </Button>
                )}
              </Space>
            ) : isExecutable ? (
              hasPermission(PERMISSIONS.CAMPAIGN_WINNER_EXECUTE) && (
                <Button onClick={() => handleCampaignSelection(record.campaignId, record.CampaignName, record.campaignStatus)}>
                  Execute
                </Button>
              )
            ) : null}
          </>
        );
      },
    },
  ];







  const handleCampaignSelection = (campaignId: string, campaignName: string, campaignStatus: string) => {

    setSpinning(true);
    getRanges(campaignId);
    setCurrentRowKey(campaignId);
    setSelectedCampaignName(campaignName)
    setCampaignStatus(campaignStatus)
    setTimeout(() => {
      setIsModalVisible(true)
      setSpinning(false);
      setButtonLoading(false);

    }, 1000);
  }







  const handleView = async (campaignName: string, campaignId: string, campaignStatus: string) => {

    try {
      setSpinning(true);

      const res = await getHistoryTransaction(campaignId) as HistoryResponse;

      if (res.success == true) {

        setTimeout(() => {
          getHistoryTransaction(campaignId)
          setCurrentRowKey(campaignId);
          setSelectedStartRange('');
          setCampaignStatus(campaignStatus)
          setSelectedCampaignName(campaignName)
          setActiveCampaignGroup(false)
          setActiveCampaign(true)
          setSpinning(false);
          setButtonLoading(false);
        }, 1000);
      } else {
        notification.error({
          message: "Faild To Calculate Winner",
          description: "Calculate Winner has been Faild",
        });
        setSpinning(false);

      }
    } catch (error) {
      notification.error({
        message: "Faild To Calculate Winner",
        description: "Calculate Winner has been Faild",
      });
      setSpinning(false);
    } finally {
      setSpinning(false);
    }
  }







  const handleOk = async (mode: "execute" | "view") => {
    setSpinning(true);
    try {
      const [startRange, endRange] = selectedStartRange.split("To").map((range) => range.trim());

      // VIEW mode → use getExecutedWinners API (fetch stored executed winners)
      if (mode === "view") {
        if (!selectedStartRange) {
          notification.warning({ message: 'Please select a date range first' });
          setSpinning(false);
          return;
        }

        try {
          const res = await getExecutedWinners(currentRowKey as string, startRange, endRange) as any;

          if (res.success) {
            const winners: any[] = Array.isArray(res.data) ? res.data : [];
            const hasData = winners.some((item: any) => item?.transactionSummary != null);

            if (!hasData) {
              notification.warning({
                message: 'No Executed Winners',
                description: 'No executed winner data found for the selected range.',
              });
              setSpinning(false);
              return;
            }

            setIsModalVisible(false);
            setLastExecutedRange(selectedStartRange);
            setSelectedStartRange('');
            setActiveCampaignGroup(true);
            setActiveCampaign(true);
            setCarousel(false);
            notification.success({ message: 'Winners loaded successfully' });
          } else {
            const errMsg = res.exceptionMsg || res.message || 'Failed to load winners';
            notification.error({ message: 'Error', description: errMsg });
          }
        } catch (err: any) {
          notification.error({
            message: 'Error',
            description: err?.message || 'An unexpected error occurred while loading winners.',
          });
        }

        setSpinning(false);
        return;
      }

      // EXECUTE mode → run the draw
      const res = await getTransaction(currentRowKey, startRange, endRange) as any;

      if (res.success == true) {
        setIsModalVisible(false);
        setLastExecutedRange(selectedStartRange);

        const winners: any[] = Array.isArray(res.data) ? res.data : [];
        const hasData = winners.some((item: any) => item?.transactionSummary != null);

        if (!hasData) {
          notification.error({
            message: "No Data Found",
            description: "Campaign executed but no transaction data was found.",
          });
          setSpinning(false);
          return;
        }

        setTimeout(() => {
          notification.success({
            message: "Calculate Winner Successfully",
            description: "Calculate Winner has been successfully",
          });
          setSelectedStartRange('');
          setActiveCampaignGroup(true);
          setActiveCampaign(true);
          setCarousel(true);
          setTimeout(() => { setCarousel(false); }, 30000);
          setSpinning(false);
        }, 3000);
      } else {
        const errorMsg = res.exceptionMsg || res.message || 'Failed to calculate winner';
        notification.error({ message: 'Error', description: errorMsg });
        setSpinning(false);
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'An unexpected error occurred while calculating the winner.',
      });
      setSpinning(false);
    }
  };








  const filteredColumns = allColumns.filter((col) => selectedColumns.includes(col.key) || col.key === 'action');

  const filteredData = dataSource.filter((item) =>
    item.StartTime.toLowerCase().includes(searchText) ||
    item.createdAt.toLowerCase().includes(searchText) ||
    item.CampaignName.toLowerCase().includes(searchText) ||
    item.EndTime.toLowerCase().includes(searchText) ||
    // item.noOfWinners.toLowerCase().includes(searchText) ||
    item.winnerFrequency.toString().includes(searchText)
  );







  const items = [
    {
      label: (
        <Checkbox
          checked={selectedColumns.includes('campaignId')}
          value={'campaignId'}
          onChange={(e) => handleCheckboxChange(e.target.checked, 'campaignId')}
        >
          Campaign ID
        </Checkbox>
      ),
      key: '0',
    },
    {
      label: (
        <Checkbox
          checked={selectedColumns.includes('StartTime')}
          value={'StartTime'}
          onChange={(e) => handleCheckboxChange(e.target.checked, 'StartTime')}
        >
          Start Time
        </Checkbox>
      ),
      key: '1',
    },
    {
      label: (
        <Checkbox
          checked={selectedColumns.includes('CampaignName')}
          value={'CampaignName'}
          onChange={(e) => handleCheckboxChange(e.target.checked, 'CampaignName')}
        >
          Campaign Name
        </Checkbox>
      ),
      key: '2',
    },
    {
      label: (
        <Checkbox
          checked={selectedColumns.includes('EndTime')}
          value={'EndTime'}
          onChange={(e) => handleCheckboxChange(e.target.checked, 'EndTime')}
        >
          End Time
        </Checkbox>
      ),
      key: '3',
    },

    {
      label: (
        <Checkbox
          checked={selectedColumns.includes('campaignStatus')}
          value={'campaignStatus'}
          onChange={(e) => handleCheckboxChange(e.target.checked, 'campaignStatus')}
        >
          campaignStatus
        </Checkbox>
      ),
      key: '4',
    },
  ];







  useEffect(() => {
    getCompletedCampaign();
  }, []);

  useEffect(() => {
    if (activeTab === 'completed') { getCompletedCampaign(); } else { getCampaignsWithStatus(); }
  }, [activeTab]);








const handleWinnerClick = async (item: any) => {

  if (!item?.campaignWinner?.campaignWinnerId) {
    notification.warning({
      message: "Invalid Selection",
      description: "Winner information is missing or incomplete.",
      placement: "topRight",
      duration: 4,
    });
    return;
  }

  const winnerId = item.campaignWinner.campaignWinnerId;
  const campaignId = currentRowKey;

  if (!campaignId) {
    notification.error({
      message: "Missing Campaign",
      description: "Campaign identifier is not available. Please try again.",
      placement: "topRight",
      duration: 5,
    });
    return;
  }


  const numericWinnerId = Number(winnerId);
  if (isNaN(numericWinnerId)) {
    notification.error({
      message: "Invalid Winner ID",
      description: "Winner ID format is incorrect.",
      placement: "topRight",
    });
    return;
  }


  setSpinning(true);
  setLoadingText(true);

  const loadingNotificationKey = `loading-winner-${numericWinnerId}`;

  notification.info({
    key: loadingNotificationKey,
    message: "Loading Transaction Details",
    description: "Fetching winner's transaction history...",
    duration: 0,
    placement: "bottomRight",
  });

  try {
  
    const response : any = await getWinnerTransaction(campaignId, numericWinnerId);

    const isSuccess =
      response?.status === 200 ||
      response?.status === "200" ||
      response?.success === true ||
      response?.statusCode === 200;

    if (isSuccess) {
      setShowSelectWinner(true);
      setIsTransactionModalVisible(true);

      notification.success({
        message: "Success",
        description: "Winner transaction details loaded successfully.",
        placement: "topRight",
        duration: 4,
      });
    } else {
  
      const errorMsg =
        response?.message ||
        response?.error ||
        response?.data?.message ||
        "Failed to load transaction details.";

      notification.error({
        message: "Failed to Load",
        description: errorMsg,
        placement: "topRight",
        duration: 5,
      });
    }
  } catch (error: any) {
  
    console.error("[handleWinnerClick] Failed:", error);

    let userMessage = "Could not fetch transaction details. Please try again later.";

  
    if (error?.response?.data?.message) {
      userMessage = error.response.data.message;
    } else if (error?.message) {
      userMessage = error.message;
    }

    if (
      typeof userMessage === "string" &&
      userMessage.includes("Failed to convert value of type 'java.lang.String' to required type 'long'")
    ) {
      userMessage = "Invalid ID format (campaign or winner ID). Please contact support.";
    }

    notification.error({
      message: "Operation Failed",
      description: userMessage,
      placement: "topRight",
      duration: 6,
    });
  } finally {

    setSpinning(false);
    setLoadingText(false);
    notification.destroy(loadingNotificationKey);
  }
};



const handleWinnerTranscation = async (item: any) => {
  if (!item?.campaignWinnerId) {
    notification.warning({
      message: "Invalid Selection",
      description: "Winner ID is missing or invalid.",
      placement: "topRight",
      duration: 4,
    });
    return;
  }
  const winnerId = item.campaignWinnerId;
  const campaignId = currentRowKey;
  console.log(currentRowKey,'current key')
  if (!campaignId) {
    notification.error({
      message: "Missing Campaign",
      description: "Campaign identifier is not available.",
      placement: "topRight",
      duration: 5,
    });
    return;
  }

  const numericWinnerId = Number(winnerId);
  if (isNaN(numericWinnerId)) {
    notification.error({
      message: "Invalid Winner ID",
      description: "Winner ID has an incorrect format.",
      placement: "topRight",
    });
    return;
  }

  setSpinning(true);
  setLoadingText(true);

  const loadingKey = `loading-winner-transaction-${numericWinnerId}`;

  notification.info({
    key: loadingKey,
    message: "Loading Transaction Details",
    description: "Retrieving winner transaction history...",
    duration: 0,
    placement: "bottomRight",
  });

  try {
    
    const response : any = await getWinnerTransaction(campaignId, numericWinnerId);

    const isSuccess =
      response?.status === 200 ||
      response?.status === "200" ||
      response?.success === true ||
      response?.statusCode === 200;

    if (isSuccess) {
      setShowSelectWinner(true);
      setIsTransactionModalVisible(true);

      notification.success({
        message: "Success",
        description: "Winner transaction details loaded successfully.",
        placement: "topRight",
        duration: 4,
      });
    } else {
      const errorMsg =
        response?.message ||
        response?.error ||
        response?.data?.message ||
        "Failed to retrieve transaction details.";

      notification.error({
        message: "Failed to Load",
        description: errorMsg,
        placement: "topRight",
        duration: 5,
      });
    }
  } catch (error: any) {
    console.error("[handleWinnerTranscation] Error:", error);

    let displayMessage = "Unable to load transaction details. Please try again.";

    if (error?.response?.data?.message) {
      displayMessage = error.response.data.message;
    } else if (error?.message) {
      displayMessage = error.message;
    }

    if (
      typeof displayMessage === "string" &&
      displayMessage.includes("Failed to convert value of type 'java.lang.String' to required type 'long'")
    ) {
      displayMessage = "Invalid ID format detected. Please contact support.";
    }

    notification.error({
      message: "Operation Failed",
      description: displayMessage,
      placement: "topRight",
      duration: 6,
    });
  } finally {
    
    setSpinning(false);
    setLoadingText(false);
    notification.destroy(loadingKey);
  }
};





  const HandletableClose = () => {
    setSpinning(true);

    setTimeout(() => {
      setIsTransactionModalVisible(true);
      setActiveCampaign(true)
      setShowSelectWinner(false);
      setSpinning(false);

    }, 2000);
  }








  useEffect(() => {
    if (Array.isArray(getCompletedCampaign_Red?.winnerTransactions?.transactionLogs)) {
      const fetchedTransactionLogs = getCompletedCampaign_Red?.winnerTransactions?.transactionLogs;

      setTransactionData([
        {
          key: '1',
          campaignWinnerId: getCompletedCampaign_Red?.winnerTransactions?.campaignWinnerId,
          transactionLogs: fetchedTransactionLogs.map((item: any) => ({
            transactionId: item.transactionId,
            amount: item.amount,
            branchCode: item.branchCode,
            customer: item.customer,
            suffix: item.suffix,
            postingDate: item.postingDate,
            valueDate: item.valueDate,
            inputBranch: item.inputBranch,
            userGroup: item.userGroup,
            referenceID: item.referenceID,
            transactionCode: item.transactionCode,
            transactionCodeDesc: item.transactionCodeDesc,
            currency: item.currency,
            debitCredit: item.debitCredit,
            timeStamp: item.timeStamp,
            narrationLine1: item.narrationLine1,
            narrationLine2: item.narrationLine2,
          })),
        },
      ]);
    } else {
      setTransactionData([]);
    }
  }, [getCompletedCampaign_Red]);







  const TransactionColumn = [
    {
      title: 'Transaction Id',
      dataIndex: 'transactionId',
      key: 'transactionId',
    },
    {
      title: 'Amount',
      dataIndex: 'transactionAmount',
      key: 'transactionAmount',
    },
    {
      title: 'Branch',
      dataIndex: 'branchIdentifier',
      key: 'branchIdentifier',
    },
    {
      title: 'Customer',
      dataIndex: 'customerIdentifier',
      key: 'customerIdentifier',
    },
    {
      title: 'Date',
      dataIndex: 'transactionDate',
      key: 'transactionDate',
    },

  ];







  const Winner = async () => {
    setSpinning(true);
    const campaignData = {
      masterCampaignId: currentRowKey,
      winnerIds: getCompletedCampaign_Red?.winner.map((item: any) => item.campaignWinner?.campaignWinnerId),
    };

    try {
      const response = await AnnounceWinner(campaignData) as AnnounceWinnerResponse;
      console.log(response, 'Response from AnnounceWinner');

      if (response.message == 'ok') {
        notification.success({
          message: "Winner successfully Announce",
        });
        setTimeout(() => {
          handleBackClick()
          setSpinning(false);
        }, 3000);
      } else {
        notification.error({
          message: "Announcement Failed",
          description: response.message || "An error occurred while announcing the winner.",
        });
        setSpinning(false);

      }
    } catch (error) {
      console.error("Error in Winner:", error);
      notification.error({
        message: "Error",
        description: "An error occurred while announcing the winner.",
      });
      setSpinning(false);

    } finally {
    }
  };









  const groupByRange = (transactions: any[]) => {
    const groupedData: Record<string, any[]> = {};
    transactions.forEach((item) => {
      const rangeKey = `${item.winningStartRange} - ${item.winningEndRange}`;
      if (!groupedData[rangeKey]) {
        groupedData[rangeKey] = [];
      }
      groupedData[rangeKey].push(item);
    });

    return groupedData;
  };

  // For COMPLETED campaigns: use historyTransactions
  const getWinnersForDisplay = () => {
    return getCompletedCampaign_Red?.historyTransactions || [];
  };

  const groupedTransactions = groupByRange(getWinnersForDisplay());

  function chunkArray(arr: any[], chunkSize: number) {
    const result = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      result.push(arr.slice(i, i + chunkSize));
    }
    return result;
  }







  // Helper: Format amount from baisa to OMR
  const formatAmount = (baisa: number | string): string => {
    const amount = typeof baisa === 'string' ? parseFloat(baisa) : baisa;
    if (isNaN(amount)) return 'N/A';
    const omr = (amount / 1000).toFixed(3);
    return `${amount.toLocaleString()} baisa (OMR ${omr})`;
  };

  // Helper: Clean and parse dataSelectedForWinners JSON
  const parseWinnersData = (raw: string): any[] => {
    if (!raw) return [];
    try {
      let cleaned = raw.replace(/^\(\d+\)\s*/, '').replace(/([{,])\s*([a-zA-Z0-9_]+)\s*:/g, '$1"$2":').replace(/'/g, '"');
      if (!cleaned.startsWith('[')) cleaned = '[' + cleaned;
      if (!cleaned.endsWith(']')) cleaned = cleaned + ']';
      return JSON.parse(cleaned);
    } catch {
      return [];
    }
  };

  const winnerList =
    getCompletedCampaign_Red?.winner?.map((item: any) => ({
      ...item,
      parsedWinners: parseWinnersData(item?.campaignWinner?.dataSelectedForWinners),
    })) || [];

  const downloadWinnersPDF = async (winnerList: any[]) => {
    setAuditLoading(true);
    // Fetch audit trail from new API
    let auditData: any = null;
    try {
      const token = localStorage.getItem('loginToken');
      const res = await fetch(`${process.env.REACT_APP_API_URL}/campaign/audit-trail/${currentRowKey}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const json = await res.json();

      // If API returned error status — show error and stop
      if (!res.ok) {
        const errMsg = json?.message || json?.exceptionMsg || `Server error (${res.status})`;
        notification.error({
          message: 'Failed to Download Audit Trail',
          description: errMsg,
          duration: 6,
        });
        setAuditLoading(false);
        return;
      }

      if (json?.status === '200' && json?.data) {
        auditData = json.data;
      } else if (json?.status && json?.status !== '200') {
        // API returned non-200 status in body
        const errMsg = json?.message || json?.exceptionMsg || 'Failed to load audit trail data';
        notification.error({
          message: 'Failed to Download Audit Trail',
          description: errMsg,
          duration: 6,
        });
        setAuditLoading(false);
        return;
      }
    } catch (e: any) {
      notification.error({
        message: 'Failed to Download Audit Trail',
        description: e?.message || 'Network error while fetching audit trail',
        duration: 6,
      });
      setAuditLoading(false);
      return;
    }

    // Fallback to winnerList if API fails
    const allWinners = auditData?.winners || winnerList;

    if (!allWinners || allWinners.length === 0) {
      notification.warning({ message: 'No winners to download' });
      setAuditLoading(false);
      return;
    }

    // Filter only executed winners (transactionSummary != null or executed === true)
    const winners = allWinners.filter((item: any) =>
      item?.transactionSummary != null || item?.executed === true || item?.customerIdentifier != null
    );
    const totalSlots = allWinners.length;
    const foundCount = winners.length;

    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    let yPos = 20;

    // HEADER
    doc.setFontSize(20);
    doc.setTextColor(9, 81, 121);
    doc.text('Audit Trail – Winner Selection & Campaign Execution', pageWidth / 2, yPos, { align: 'center' });
    yPos += 8;
    doc.setFontSize(10);
    doc.setTextColor(100);
    doc.text('CBO Circular BM1167 Compliance Report', pageWidth / 2, yPos, { align: 'center' });
    yPos += 12;

    // Campaign Details from audit API
    doc.setFontSize(11);
    doc.setTextColor(40);
    const details = [
      ['Campaign Name:', auditData?.campaignName || selectedCampaignName || 'N/A'],
      ['Campaign ID:', String(auditData?.campaignId || currentRowKey || 'N/A')],
      ['Start Date:', `${auditData?.startDate || 'N/A'}  ${auditData?.startTime || ''}`.trim()],
      ['End Date:', `${auditData?.endDate || 'N/A'}  ${auditData?.endTime || ''}`.trim()],
      ['Winner Frequency:', auditData?.winnerFrequency || 'N/A'],
      ['No. of Winners:', `${foundCount} Found out of ${totalSlots} Slots`],
      ['Campaign Status:', auditData?.campaignStatus || 'N/A'],
      ['Execution Date:', auditData?.executionDate ? new Date(auditData.executionDate).toLocaleString() : 'N/A'],
      ['Winner Branch Excluded:', auditData?.isWinnerBranchExcluded ? 'Yes' : 'No'],
      ['Blacklisted Cust. Excl.:', auditData?.blackListedCustomerExcluded ? 'Yes' : 'No'],
      ['Approved:', auditData?.isApproved ? 'Yes' : 'No'],
      ['Mock Campaign:', auditData?.isMockCampaign ? 'Yes' : 'No'],
      ['Institution ID:', String(auditData?.instId || 'N/A')],
      ['Generated On:', new Date().toLocaleString()],
      ['Executed By:', getDecodedToken()?.userName || 'System'],
    ];

    details.forEach(([label, value]) => {
      doc.setFont('helvetica', 'bold');
      doc.text(String(label), 14, yPos);
      doc.setFont('helvetica', 'normal');
      doc.text(String(value), 70, yPos);
      yPos += 6;
    });
    yPos += 5;

    // ── WINNERS SUMMARY TABLE ────────────────────────────────────────────────
    const parseReplacementHistory = (raw: string | null): string => {
      if (!raw) return '-';
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length > 0) {
          return parsed.map((r: any) => `Replaced: ${r.replacedWinner || 'N/A'}`).join(', ');
        }
        return '-';
      } catch {
        return '-';
      }
    };

    const summaryRows = winners.map((item: any, idx: number) => {
      // Handle both execute API format (transactionSummary) and audit API format (flat fields)
      const customerId = item?.transactionSummary?.customer || item?.customerIdentifier || 'N/A';
      const customerName = item?.transactionSummary?.customer_name || item?.accountShortName || '-';
      const transactionId = item?.transactionSummary?.transaction_id || item?.transactionId || 'N/A';
      const amount = item?.transactionSummary?.total_amount ?? item?.transactionAmount;
      const winner = item?.campaignWinner || item;
      return [
        String(idx + 1),
        customerId,
        String(transactionId),
        amount != null ? `OMR ${Number(amount).toFixed(2)}` : 'N/A',
        winner?.prizeGift || winner?.prizeAmount || 'N/A',
        winner?.prizeType || 'N/A',
        item?.trxCount != null ? String(item.trxCount) : 'N/A',
        winner?.executedAt ? new Date(winner.executedAt).toLocaleString() : 'N/A',
        winner?.executed === true || winner?.isExecuted === true ? 'Executed' : 'Not Executed',
        parseReplacementHistory(item?.replacementHistory || winner?.replacementHistory),
      ];
    });

    autoTable(doc, {
      startY: yPos,
      head: [['#', 'Customer ID', 'Transaction ID', 'Transaction Amount', 'Prize', 'Prize Type', 'Trx Count', 'Executed At', 'Status', 'Replacement History']],
      body: summaryRows,
      headStyles: { fillColor: [9, 81, 121], textColor: 255, fontSize: 10 },
      styles: { fontSize: 9, cellPadding: 3 },
      alternateRowStyles: { fillColor: [245, 245, 245] },
      margin: { left: 14, right: 14 },
    });

    yPos = (doc as any).lastAutoTable.finalY + 10;

    // ── TRANSACTION DETAILS PER WINNER ───────────────────────────────────────
    winners.forEach((item: any, idx: number) => {
      const trxList: any[] = Array.isArray(item.transactionObject) ? item.transactionObject : [];
      if (trxList.length === 0) return;

      if (yPos > 240) { doc.addPage(); yPos = 20; }

      doc.setFontSize(11);
      doc.setTextColor(9, 81, 121);
      doc.text(
        `Winner #${idx + 1} Transactions — ${item.customerIdentifier || 'N/A'} (${trxList.length} records)`,
        14, yPos
      );
      yPos += 4;

      const trxRows = trxList.map((t: any) => [
        String(t.transactionId || '-'),
        String(t.bankTransactionId || '-'),
        t.transactionDate ? t.transactionDate.split('T')[0] : '-',
        t.transactionAmount != null ? `OMR ${Number(t.transactionAmount).toFixed(2)}` : '-',
        t.customerIdentifier || '-',
        t.branchIdentifier || '-',
        t.accountShortName || '-',
      ]);

      autoTable(doc, {
        startY: yPos,
        head: [['Trx ID', 'Bank Trx ID', 'Date', 'Amount', 'Customer ID', 'Branch', 'Account Name']],
        body: trxRows,
        headStyles: { fillColor: [9, 81, 121], textColor: 255, fontSize: 9 },
        styles: { fontSize: 8, cellPadding: 2 },
        alternateRowStyles: { fillColor: [250, 250, 250] },
        margin: { left: 14, right: 14 },
      });

      yPos = (doc as any).lastAutoTable.finalY + 10;
    });

    // FAIRNESS INFO
    doc.addPage();
    yPos = 20;
    doc.setFontSize(14);
    doc.setTextColor(9, 81, 121);
    doc.text('Selection Logic & Fairness Information', 14, yPos);
    yPos += 8;
    doc.setFontSize(10);
    doc.setTextColor(60);
    const fairnessText = [
      `Selection Method: Winners selected based on configured campaign criteria.`,
      'Execution: Automated system execution with no manual overrides.',
      'Fairness: All eligible transactions processed uniformly per CBO BM1167 requirements.',
      `Blacklisted Customers Excluded: ${auditData?.blackListedCustomerExcluded ? 'Yes' : 'No'}`,
      `Winner Branch Excluded: ${auditData?.isWinnerBranchExcluded ? 'Yes' : 'No'}`,
      `Timestamp: ${new Date().toISOString()}`,
    ];
    fairnessText.forEach((line) => {
      doc.text(line, 14, yPos, { maxWidth: pageWidth - 28 });
      yPos += 6;
    });
    yPos += 10;

    // COMPLIANCE FOOTER
    doc.addPage();
    yPos = 20;
    doc.setFontSize(14);
    doc.setTextColor(9, 81, 121);
    doc.text('Compliance & Regulatory Statements', 14, yPos);
    yPos += 10;
    doc.setFontSize(10);
    doc.setTextColor(60);
    const complianceText = [
      '• All customer data processed in compliance with Banking Law and customer confidentiality requirements.',
      '• No manual overrides performed. Selection logic applied uniformly across all eligible entries.',
      '• Fairness and transparency ensured as per CBO BM1167 Annexure I (viii).',
      '• This report serves as an auditable record for regulatory review and internal compliance.',
    ];
    complianceText.forEach((line) => {
      doc.text(line, 14, yPos, { maxWidth: pageWidth - 28 });
      yPos += 8;
    });

    // Page numbers
    const pageCount = doc.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.setTextColor(150);
      doc.text(`Page ${i} of ${pageCount}`, pageWidth - 30, doc.internal.pageSize.height - 10);
    }

    doc.save(`CBO_Audit_Trail_${auditData?.campaignName || selectedCampaignName || 'Campaign'}_${new Date().toISOString().split('T')[0]}.pdf`);
    notification.success({ message: 'Audit trail PDF downloaded successfully' });
    setAuditLoading(false);
  };




  console.log(getCompletedCampaign_Red, 'getCompletedCampaign_Red')





  return (
    <>
      <Header />
      <Spin spinning={spinning} fullscreen />
      {boom && <div className={styles.boom}></div>}

      {showSelectWinner ? (
        <>
          <h4 className="mx-4 mt-3">Winner Transactions</h4>
          <div className={styles.transactionDetail}>
            <IoCloseSharp className={styles.Close_Icon} onClick={HandletableClose} />
            <Table
              loading={loadingText}
              columns={TransactionColumn}
              dataSource={Array.isArray(getCompletedCampaign_Red?.winnerTransactions?.transactions) ? getCompletedCampaign_Red?.winnerTransactions?.transactions : []}
              pagination={false}
              // rowSelection={{
              //   type: 'checkbox',
              //   onChange: (selectedKeys) => setSelectedRowKeys(selectedKeys),
              // }}
              size="small"
              onChange={(pagination, filters, sorter) => {
                if (!Array.isArray(sorter)) {
                  console.log('Field:', sorter.field);
                  console.log('Order:', sorter.order);
                }
              }}
            />
            <Pagination
              align="end"
              showTotal={(total) => `Total ${total} items`}
              current={currentPage}
              pageSize={pageSize}
              onChange={(page, newSize) => {
                setCurrentPage(page);
                setPageSize(newSize);
              }}
              style={{ marginTop: 16 }}
            />
          </div>
        </>
      ) : (
        activeCampaign ? (
          campaignStatus === 'COMPLETED' || campaignStatus === 'ARCHIVED' ? (
            <div className={`container-fluid ${styles.container2}`}>
              <div className={styles.backIcon} onClick={handleBackClick}>
                <FaArrowLeft color="#095179" size={24} style={{ cursor: "pointer", margin: "10px" }} />
              </div>

              <h2 className={styles.headingPage}>Campaign Winner's</h2>
              <div className={`row ${styles.headrow}`} >
                <div className={`col-lg-11 ${styles.winner}`}>
                  <div className={styles.heading}>
                    <h1>Winner Of Campaign,<br /></h1>
                    <h3>{`${selectedCampaignName}`}</h3>
                  </div>
                  <img src={LuckyDraw} alt="Lucky Draw" className={styles.winnerImage} />
                </div>
              </div>
              <div className="col-12">
                <div style={{ marginBottom: 12 }}>
                  <Button loading={auditLoading} onClick={() => downloadWinnersPDF(winnerList)}>Download Audit Trail</Button>
                </div>
                {Object.keys(groupedTransactions).length > 0 ? (
                  Object.entries(groupedTransactions).map(([range, transactions], index) => (
                    <div key={index} className={`my-4 ${styles.rangeGroup}`}>
                      <h6 className="text-start py-0 my-0">{`Winning Range: ${range}`}</h6>
                     
                      {transactions.map((item: any, i: number) => (
                        <div className={`row my-3 ${styles.winnerRow}`} key={i}>
                          <div className={`col-lg-8 ${styles.WinnerAnnauce}`}>
                            <div className={styles.imagewinner}>
                              <div className={
                                item.winningPosition === 1
                                  ? styles.imagewinner1
                                  : item.winningPosition === 2
                                    ? styles.imagewinner2
                                    : item.winningPosition === 3
                                      ? styles.imagewinner3
                                      : styles.imagewinner4
                              }>
                                <h2 className={styles.coinText}>
                                  {item.winningPosition === 1
                                    ? "1"
                                    : item.winningPosition === 2
                                      ? "2"
                                      : item.winningPosition === 3
                                        ? "3"
                                        : item.winningPosition}
                                </h2>
                              </div>
                            </div>
                            {/* <div className={styles.imagewinner}>
                              <img
                                src={
                                  item.winningPosition == 1
                                    ? Coin_1st
                                    : item.winningPosition == 2
                                      ? Coin_2nd
                                      : Coin_3rd
                                }
                                width={90}
                                alt="Winner"
                              />
                            </div> */}
                            <span className={styles.Prize}>
                              <h5>{`Customer Id : ${item?.customerIdentifier || item?.campaignWinnerId}`}</h5>
                              {getCustomerName(item?.accountShortName) && (
                                <h5>{`Customer Name : ${getCustomerName(item?.accountShortName)}`}</h5>
                              )}
                            </span>

                          </div>
                          <div className={`col-lg-3 ${styles.Amount}`}>
                            <span>
                              <h6>{`Position ${item.winningPosition}`}</h6>
                              <h3>{`${item?.prizeGift ? "Gift" : "Prize"} : ${item?.prizeGift ? item?.prizeGift : item?.prizeAmount}`}</h3>
                              <h2>{item?.winnerFrequency}</h2>
                            </span>
                            <span className={styles.Arrow}>
                              {hasPermission(PERMISSIONS.CAMPAIGN_WINNER_TRX_VIEW) && (
                              <FaArrowRightLong
                                className={styles.arrowICon}
                                onClick={() => handleWinnerTranscation(item)}
                              />
                              )}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  ))
                ) : (
                  <div style={{ textAlign: "center", padding: "20px 0" }}>
                    <h3>No Winner Found</h3>
                  </div>
                )}
              </div>

              {/* <div className="col-12">
                {getCompletedCampaign_Red?.historyTransactions && getCompletedCampaign_Red?.historyTransactions.length > 0 ? (
                  getCompletedCampaign_Red?.historyTransactions.some((item: any) => item?.transactionId) ? (
                    getCompletedCampaign_Red?.historyTransactions.map((item: any, index: number) => {
                      return item?.transactionId ? (
                        <div className={`row my-3 ${styles.winnerRow}`} key={index}>
                          <div className={`col-lg-8 ${styles.WinnerAnnauce}`}>
                            <div className={styles.imagewinner}>
                              <img
                                src={
                                  item.winningPosition == 1
                                    ? Coin_1st
                                    : item.winningPosition == 2
                                      ? Coin_2nd
                                      : Coin_3rd
                                }
                                width={90}
                                alt="Winner"
                              />
                            </div>
                            <span className={styles.Prize}>
                              <h5>{`Customer Id : ${item?.customerIdentifier || item?.transactionId}`}</h5>
                              {getCustomerName(item?.accountShortName) && (
                                <h5>{`Customer Name : ${getCustomerName(item?.accountShortName)}`}</h5>
                              )}
                            </span>
                          </div>
                          <div className={`col-lg-3 ${styles.Amount}`}>
                            <span>
                              <h6>{`Position ${item.winningPosition}`}</h6>
                              <h3>{`${item?.prizeGift ? "Gift" : "Prize"} : ${item?.prizeAmount}`}</h3>
                              <h2>Current Month</h2>
                            </span>
                            <span className={styles.Arrow}>
                              <FaArrowRightLong
                                className={styles.arrowICon}
                                onClick={() => handleWinnerClick(item)}
                              />
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className={`row my-3 ${styles.winnerRow}`} key={index}>
                          <div className={`col-lg-8 ${styles.WinnerAnnauce}`} style={{ textAlign: "center" }}>
                            <div className={styles.imagewinner}>
                              <img
                                src={
                                  item.campaignWinner?.winningPosition == 1
                                    ? Coin_1st
                                    : item.campaignWinner?.winningPosition == 2
                                      ? Coin_2nd
                                      : Coin_3rd
                                }
                                width={90}
                                alt="Winner"
                              />
                            </div>
                            <h6>No Transaction Details Found</h6>
                          </div>
                          <div className={`col-lg-3 ${styles.Amount}`}>

                            <span>
                              <h6>{`Position ${item.campaignWinner?.winningPosition}`}</h6>
                              <h3>{`${item.campaignWinner?.prizeGift ? "Gift" : "Prize"} : ${item.campaignWinner?.prizeAmount}`}</h3>
                              <h2>Current Month</h2>
                            </span>
                            <span className={styles.Arrow}>
                              <FaArrowRightLong
                                className={styles.arrowICon}
                                onClick={() => handleWinnerClick(item)}
                              />
                            </span>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div style={{ textAlign: "center", padding: "20px 0" }}>
                      <h3>No Winner Found</h3>
                    </div>
                  )
                ) : (
                  <div style={{ textAlign: "center", padding: "20px 0" }}>
                    <h3>No Winner Found</h3>
                  </div>
                )}

              </div> */}


            </div>
          )
            :

            (
              <div className={`container-fluid ${styles.container2}`}>
                <div className={styles.backIcon} onClick={handleBackClick}>
                  <FaArrowLeft color="#095179" size={24} style={{ cursor: "pointer", margin: "10px" }} />
                </div>

                <h2 className={styles.headingPage}>Campaign Winner's</h2>
                <div className={`row ${styles.headrow}`} >
                  <div className={`col-lg-11 ${styles.winner}`}>
                    <div className={styles.heading}>
                      <h1>Winner Of Campaign,<br /></h1>
                      <h3>{`${selectedCampaignName}`}</h3>
                    </div>
                    <img src={LuckyDraw} alt="Lucky Draw" className={styles.winnerImage} />
                  </div>
                </div>
                {getCompletedCampaign_Red?.winner && getCompletedCampaign_Red?.winner.some((item: any) => item?.transactionSummary) ? (

                  <div className={`col-11 ${styles.AnounceBtn}`}>
                    {hasPermission(PERMISSIONS.CAMPAIGN_WINNER_ANNOUNCE) && (
                      <Button onClick={Winner}>Anounce Winner</Button>
                    )}
                    <Button
                      onClick={handleReplaceWinner}
                      disabled={selectedWinnerIds.length === 0}
                      style={{ marginLeft: 10 }}
                    >
                      Replace Winner
                    </Button>
                  </div>
                ) : null}

                <Modal
                  title="Replace Winner — Add Comment"
                  open={replaceCommentModal}
                  onOk={confirmReplaceWinner}
                  onCancel={() => setReplaceCommentModal(false)}
                  okText="Confirm Replace"
                  cancelText="Cancel"
                  okButtonProps={{ disabled: !replaceComment.trim() }}
                >
                  <p>Please provide a reason for replacing the selected winner(s):</p>
                  <Input.TextArea
                    rows={4}
                    placeholder="Enter comment..."
                    value={replaceComment}
                    onChange={(e) => setReplaceComment(e.target.value)}
                    maxLength={500}
                    showCount
                  />
                </Modal>

                {showCarousel ?
                  <div style={{ padding: '16px 0' }}>
                    <SlotMachine
                      winners={winnerList
                        .filter((item: any) => item?.transactionSummary != null)
                        .map((item: any, idx: number) => {
                        const summary = item.transactionSummary || {};
                        const parsed = item.parsedWinners?.[0] || {};
                        return {
                          position: item.campaignWinner?.winningPosition ?? (idx + 1),
                          customerId: summary.customer || parsed.customer || item.campaignWinner?.customerIdentifier || 'N/A',
                          customerName: getCustomerName(summary.customer_name || parsed.customer_name),
                          prize: item.campaignWinner?.prizeGift || item.campaignWinner?.prizeAmount || 'N/A',
                          prizeLabel: item.campaignWinner?.prizeGift ? 'Gift' : 'Prize',
                        };
                      })}
                      onDone={() => setCarousel(false)}
                      getCustomerNameFn={getCustomerName}
                      winnerList={winnerList.filter((item: any) => item?.transactionSummary != null)}
                      stylesRef={styles}
                    />
                  </div>
                  :
                  <div className="col-12">
                    <Button loading={auditLoading} onClick={() => downloadWinnersPDF(winnerList)}>Download Audit Trail</Button>
                    
                    {getCompletedCampaign_Red?.winner && getCompletedCampaign_Red?.winner.length > 0 && getCompletedCampaign_Red?.winner.some((item: any) => item?.transactionSummary != null) ? (
                      (() => {
                        const foundWinners = getCompletedCampaign_Red.winner.filter((item: any) => item?.transactionSummary != null);
                        const foundCount = foundWinners.length;
                        // Get total slots from campaign data (noOfWinners * number of ranges)
                        const currentCampaign = dataSource.find((d: any) => String(d.campaignId) === String(currentRowKey));
                        const totalSlots = getCompletedCampaign_Red.winner.length > foundCount
                          ? getCompletedCampaign_Red.winner.length  // API returned all slots
                          : currentCampaign?.noOfWinners
                            ? Number(currentCampaign.noOfWinners)
                            : foundCount; // fallback
                        return (
                          <>
                            <div style={{ margin: '12px 0', padding: '8px 16px', background: '#f0f9ff', borderRadius: 8, display: 'inline-block' }}>
                              <span style={{ fontWeight: 600, color: '#095179', fontSize: 14 }}>
                                🏆 {foundCount} Winner{foundCount !== 1 ? 's' : ''} Found out of {totalSlots} Slots
                              </span>
                            </div>
                            {foundWinners.map((item: any, index: number) => (
                            <div className={`row my-3 ${styles.winnerRow}`} key={index}>
                              <div className={`col-lg-8 ${styles.WinnerAnnauce}`}>
                                <Checkbox
                                  style={{ marginRight: 10 }}
                                  checked={selectedWinnerIds.includes(item.campaignWinner?.campaignWinnerId)}
                                  onChange={(e) => {
                                    const id = item.campaignWinner?.campaignWinnerId;
                                    setSelectedWinnerIds(prev => e.target.checked ? [...prev, id] : prev.filter(x => x !== id));
                                  }}
                                />
                                <div className={styles.imagewinner}>
                                  <div className={
                                    item.campaignWinner?.winningPosition === 1
                                      ? styles.imagewinner1
                                      : item.campaignWinner?.winningPosition === 2
                                        ? styles.imagewinner2
                                        : item.campaignWinner?.winningPosition === 3
                                          ? styles.imagewinner3
                                          : styles.imagewinner4
                                  }>
                                    <h2 className={styles.coinText}>
                                      {item.campaignWinner?.winningPosition === 1
                                        ? "1"
                                        : item.campaignWinner?.winningPosition === 2
                                          ? "2"
                                          : item.campaignWinner?.winningPosition === 3
                                            ? "3"
                                            : item.campaignWinner?.winningPosition}
                                    </h2>
                                  </div>
                                </div>
                                <span className={styles.Prize}>
                                  <h5>{`Customer Id : ${item?.transactionSummary?.customer}`}</h5>
                                  {getCustomerName(item?.transactionSummary?.customer_name) && (
                                    <h5>{`Customer Name : ${getCustomerName(item?.transactionSummary?.customer_name)}`}</h5>
                                  )}
                                </span>
                              </div>
                              <div className={`col-lg-3 ${styles.Amount}`}>
                                <span>
                                  <h6>{`Position ${item.campaignWinner?.winningPosition}`}</h6>
                                  <h3>{`${item.campaignWinner?.prizeGift ? "Gift" : "Prize"} : ${item.campaignWinner?.prizeGift ? item.campaignWinner?.prizeGift : item.campaignWinner?.prizeAmount}`}</h3>
                                  <h2>Current Month</h2>
                                </span>
                                <span className={styles.Arrow}>
                                  {hasPermission(PERMISSIONS.CAMPAIGN_WINNER_TRX_VIEW) && (
                                    
                                  <FaArrowRightLong
                                    className={styles.arrowICon}
                                    onClick={() => handleWinnerClick(item)}
                                  />
                                  )}
                                </span>
                              </div>
                            </div>
                          ))}
                          </>
                        );
                      })()
                    ) : (
                      <div style={{ textAlign: "center", padding: "20px 0" }}>
                        <h3>No Winner Found</h3>
                      </div>
                    )}

                  </div>
                }



              </div>
            )
        ) : (
          <>
            {/* Modal and Table Content */}
            <Modal
              title={"Execute Campaign"}
              visible={isModalVisible}
              onOk={async () => {
                const selectedItem = getCompletedCampaign_Red?.data2?.find(
                  (item: any) => `${item.winningStartRange} To ${item.winningEndRange}` === selectedStartRange
                );

                const newAction = selectedItem?.executedCount > 0 ? "view" : "execute";
                setActionType(newAction);
                handleOk(newAction);
              }}
              onCancel={handleCancel}
              afterClose={() => {
                setSelectedStartRange('');
                setCampaignStatus('');
              }}
                            okText={(() => {
                const d2 = getCompletedCampaign_Red?.data2;
                const ranges: any[] = Array.isArray(d2) ? d2 : (d2 && d2.winningStartRange ? [d2] : []);
                const total = ranges.length;
                const executedCount = ranges.filter((r: any) => r.executedCount > 0).length;
                const selectedItem = ranges.find((r: any) => `${r.winningStartRange} To ${r.winningEndRange}` === selectedStartRange);
                if (!selectedStartRange) return executedCount > 0 && executedCount < total ? 'Executed' : 'Execute';
                if (total === 1) return selectedItem?.executedCount > 0 ? 'View' : 'Execute';
                if (selectedItem?.executedCount > 0) return 'View';
                return executedCount > 0 && executedCount < total ? 'Executed' : 'Execute';
              })()}
              okButtonProps={{
                style: { backgroundColor: '#095179', color: '#ffffff' },
              }}
            >
              <Form layout="vertical">
                <Form.Item label="Select Start Range">
                  <Select
                    placeholder="Select Start Range To End Range"
                    value={selectedStartRange || undefined}
                    onChange={(value) => setSelectedStartRange(value)}
                  >
                    {(() => {
                      const d2 = getCompletedCampaign_Red?.data2;
                      const ranges: any[] = Array.isArray(d2) ? d2 : (d2 && d2.winningStartRange ? [d2] : []);
                      return ranges.map((item: any, index: number) => (
                        <Option key={index} value={`${item.winningStartRange} To ${item.winningEndRange}`}>
                          {`${item.winningStartRange.slice(0, 10)} To ${item.winningEndRange.slice(0, 10)}${item.executedCount > 0 ? ' (Executed)' : ''}`}
                        </Option>
                      ));
                    })()}
                  </Select>
                </Form.Item>
                {(() => {
                  const d2 = getCompletedCampaign_Red?.data2;
                  const ranges: any[] = Array.isArray(d2) ? d2 : (d2 && d2.winningStartRange ? [d2] : []);
                  const executedRanges = ranges.filter((r: any) => r.executedCount > 0).length;
                  const selectedItem = ranges.find((r: any) => `${r.winningStartRange} To ${r.winningEndRange}` === selectedStartRange);
                  if (!selectedStartRange || ranges.length === 0) return null;
                  return (
                    <div style={{ marginTop: '10px' }}>
                      <span>{`Winners Count: ${selectedItem?.count ?? ''}`}</span>
                      {selectedItem?.executedCount > 0 && (
                        <span style={{ marginLeft: '10px', color: 'green' }}>Status: Executed</span>
                      )}
                      {ranges.length > 1 && executedRanges > 0 && executedRanges < ranges.length && (
                        <span style={{ marginLeft: '10px', color: 'orange' }}>
                          {`Executed (${executedRanges}/${ranges.length} ranges done)`}
                        </span>
                      )}
                    </div>
                  );
                })()}
              </Form>
            </Modal>

            {/* Search and Filter */}
            <div className={styles.Route}>
              <h5>Campaign Winner's</h5>
              <div className={styles.btns}></div>
            </div>
            <div className={styles.container}>
              <Tabs
                activeKey={activeTab}
                onChange={(key) => { setActiveTab(key); setCurrentPage(1); }}
                items={[
                  { key: 'completed', label: 'Completed Campaigns' },
                  { key: 'allStatus', label: 'All Campaigns' },
                  { key: 'executed', label: 'Executed Campaigns' },
                  { key: 'archived', label: 'Archived Campaigns' },
                ]}
                style={{ marginBottom: 8, paddingLeft: 8 }}
              />
              <Space className={styles.SearchTable}>
                <div className={styles.SearchBar}>
                  <Input
                    placeholder="Search..."
                    prefix={<CiSearch size={20} />}
                    onChange={(e) => onSearch(e.target.value)}
                    style={{ width: 200 }}
                    className={styles.inputSearch}
                  />
                  <Dropdown menu={{ items }} trigger={['click']}>
                    <SettingOutlined className={styles.tableSettings} />
                  </Dropdown>
                </div>
              </Space>
              <Table
                loading={loadingText}
                columns={filteredColumns}
                dataSource={filteredData.slice((currentPage - 1) * pageSize, currentPage * pageSize)}
                pagination={false}
                rowSelection={{
                  type: 'checkbox',
                  onChange: (selectedKeys) => setSelectedRowKeys(selectedKeys),
                }}
                size="small"
                onChange={(pagination, filters, sorter) => {
                  if (!Array.isArray(sorter)) {
                    console.log('Field:', sorter.field);
                    console.log('Order:', sorter.order);
                  }
                }}
              />
              <Pagination
                align="end"
                showTotal={(total) => `Total ${total} items`}
                current={currentPage}
                total={filteredData.length}
                pageSize={pageSize}
                onChange={(page, newSize) => {
                  setCurrentPage(page);
                  setPageSize(newSize);
                }}
                style={{ marginTop: 16 }}
              />
            </div>
          </>
        )
      )}
    </>
  );
};


function mapStateToProps(state: any) {
  return {
    getCompletedCampaign_Red: state.getCompletedCampaign_Red,
  };
}


export default connect(mapStateToProps, Actions)(LuckyDrawScreen);
